
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.808.056a24.808 24.808 0 1024.807 24.808A24.797 24.797 0 0024.808.056zM16.51 24.457h-3.14v4.88a3.152 3.152 0 003.141 3.152v4.067a7.219 7.219 0 01-7.208-7.218v-4.88H6.15V20.39h3.152v-7.056h4.067v7.055h3.141v4.067zm12.974-7.208a3.15 3.15 0 00-3.162 3.142h3.162v4.066h-3.162v4.88a7.229 7.229 0 01-7.22 7.22v-4.068a3.152 3.152 0 003.143-3.151v-4.88h-3.142V20.39h3.142a7.228 7.228 0 017.239-7.22v4.078zm12.942 15.25v4.067a7.219 7.219 0 01-7.208-7.218v-4.89h-3.152V20.39h3.152v-7.056h4.067v7.055h3.141v4.067h-3.162v4.88a3.151 3.151 0 003.142 3.142l.02.02z","fill":"#E73373"}})])
          )
        }
      }
    